import { isRouteErrorResponse } from 'react-router-dom';

export const isStaleChunkError = (error: unknown): boolean =>
	error instanceof Error &&
	/Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
		error.message,
	);

export const buildErrorEventPayload = (error: unknown, url: string) => {
	if (isRouteErrorResponse(error)) {
		return {
			url,
			error_message: error.statusText,
			error_status: error.status,
			is_stale_chunk: false,
		};
	}

	return {
		url,
		error_message:
			error instanceof Error ? error.message : String(error ?? 'unknown'),
		error_status: null,
		is_stale_chunk: isStaleChunkError(error),
	};
};
